export type Environment = 'dev1' | 'dev2' | 'dev3' | 'dev4' | 'dev5' | 'qa' | 'production' | 'development';

const segmentAnalyticsHtmlPath = 'analytics/segment-analytics.html';

export const getSegmentIframeUrl = (env: Environment) => {
	if (env === 'production') return `https://tags.chime.com/${segmentAnalyticsHtmlPath}`;
	if (env === 'development') return `https://tags-qa.chime.com/${segmentAnalyticsHtmlPath}`;
	return `https://tags-${env}.chime.com/${segmentAnalyticsHtmlPath}`;
};

export const getTargetOrigin = (env: Environment) => {
	if (env === 'production') return 'https://tags.chime.com';
	if (env === 'development') return 'https://tags-qa.chime.com';
	return `https://tags-${env}.chime.com`;
};
